export default {
  namespaced: true,

  state() {
    return {
      visible: false,
      isLoading: false,
      isOverlayLandingPage: false,
    };
  },

  getters: {},
  mutations: {
    SET_OVERLAY_VISIBLE: (state: any) => {
      state.visible = true;
    },
    SET_OVERLAY_HIDDEN: (state: any) => {
      state.visible = false;
    },
  },
  actions: {
    showOverlay: ({ commit, state }, params: any) => {
      if (params) {
        state.isOverlayLandingPage = true;
      }
      commit("SET_OVERLAY_VISIBLE");
    },
    hideOverlay: ({ commit, state }) => {
      state.isOverlayLandingPage = false;
      commit("SET_OVERLAY_HIDDEN");
    },
  },
};
